var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reset-password-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c00000;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-1",
    d: "M7.5,15.667h-6a1.5,1.5,0,0,1-1.5-1.5V8.5A1.5,1.5,0,0,1,1.5,7H9.167a1.5,1.5,0,0,1,1.5,1.5v2a.5.5,0,0,1-1,0v-2a.5.5,0,0,0-.5-.5H1.5a.5.5,0,0,0-.5.5v5.667a.5.5,0,0,0,.5.5h6a.5.5,0,1,1,0,1Z",
    transform: "translate(0 -2.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-1",
    d: "M9.167,5.667a.5.5,0,0,1-.5-.5V3.333A2.333,2.333,0,1,0,4,3.333V5.167a.5.5,0,1,1-1,0V3.333a3.333,3.333,0,1,1,6.667,0V5.167A.5.5,0,0,1,9.167,5.667Z",
    transform: "translate(-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-1",
    d: "M22.333,16.833H21a.5.5,0,0,1,0-1h.833V15a.5.5,0,0,1,1,0v1.333A.5.5,0,0,1,22.333,16.833Z",
    transform: "translate(-6.833 -4.833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-1",
    d: "M14.5,22.333a.5.5,0,0,1-.5-.5V20.5a.5.5,0,0,1,.5-.5h1.333a.5.5,0,1,1,0,1H15v.833A.5.5,0,0,1,14.5,22.333Z",
    transform: "translate(-4.667 -6.667)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-1",
    d: "M14.69,17a.522.522,0,0,1-.145-.021.5.5,0,0,1-.333-.624,3.328,3.328,0,0,1,6.121-.589.5.5,0,1,1-.885.469,2.327,2.327,0,0,0-4.279.411A.5.5,0,0,1,14.69,17Z",
    transform: "translate(-4.73 -4.667)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-1",
    d: "M17.5,22.5a3.315,3.315,0,0,1-2.935-1.765.5.5,0,0,1,.885-.469,2.327,2.327,0,0,0,4.28-.415.5.5,0,1,1,.954.3A3.32,3.32,0,0,1,17.5,22.5Z",
    transform: "translate(-4.837 -6.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/reset-password.9de21c31288075d03c94a08f30c6effa.svg";
export { ForwardRef as ReactComponent };